import React, { useCallback, useEffect, useState } from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import FeatureDialog from "./FeatureForm";
import ToolBar from "../../components/Layout/ToolBar";
import useTable from '../../components/useTable';
import * as featureService from '../../services/featureService';
import ActionsTableCell from '../../components/MaterialTable/ActionsTableCell';
import useAlert from '../../components/useAlert';
import useLinearProgress from '../../components/useLinearProgress';
import AlertDialog from '../../components/AlertDialog';

const featureColumns = [
    { id: 'id', label: 'ID' },
    { id: 'type', label: 'Type' },
    { id: 'description', label: 'Description' },
    { id: 'defaultValue', label: 'Default Value' },
];

const FEATURE_DIALOGS = {
    CREATE_EDIT_DIALOG: 'feature',
    CONFIRMATION_DIALOG: 'alert'
}

const Features = () => {
    const [features, setFeatures] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [open, setOpen] = useState(false);
    const [dialogType, setDialogType] = useState("");

    const {
        TblContainer,
        TblHead
    } = useTable(features, featureColumns);

    const {
        Alert,
        status,
        showSuccess,
        showError
    } = useAlert();

    const {
        LinearPorgress,
        isLoading,
        setIsLoading
    } = useLinearProgress(true);

    const getFeatures = useCallback(() => {
        featureService.getFeatures()
            .then((response) => {
                const result = response.data.items;
                setFeatures(result || []);
            })
            .catch(error => {
                showError(error.response?.data?.message || "Error fetching Features");
            }).finally(() => {
                setIsLoading(false);
            });
    }, [showError, setIsLoading]);

    useEffect(() => {
        getFeatures();
    }, [getFeatures]);

    const handleDeleteClicked = () => {
        featureService.removeFeature(selectedRow.id)
            .then(() => {
                showSuccess();
                getFeatures();
            }).catch(error => {
                showError(error.response?.data?.message || "Error deleting Feature");
            });
    }

    return (
        <React.Fragment>
            {status ? <Alert /> : null}
            <ToolBar
                title="Add Feature"
                setOpen={() => {
                    setSelectedRow(null);
                    setDialogType(FEATURE_DIALOGS.CREATE_EDIT_DIALOG);
                    setOpen(true);
                }}
            />
            {isLoading ? <LinearPorgress /> :
            <TblContainer>
                <TblHead />
                <TableBody>
                    {features && features.map(key => (
                        <TableRow
                            key={key.id}
                            onClick={() => setSelectedRow(key)}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell >{key.id}</TableCell>
                            <TableCell >{key.type}</TableCell>
                            <TableCell >{key.description}</TableCell>
                            <TableCell >{key.defaultValue}</TableCell>
                            <ActionsTableCell
                                onEdit={() => {
                                    setDialogType(FEATURE_DIALOGS.CREATE_EDIT_DIALOG);
                                    setOpen(true);
                                }}
                                onDelete={(e) => {
                                    setDialogType(FEATURE_DIALOGS.CONFIRMATION_DIALOG);
                                    setOpen(true);
                                }}
                            />
                        </TableRow>
                    ))}
                </TableBody>
            </TblContainer>}
            {dialogType === FEATURE_DIALOGS.CREATE_EDIT_DIALOG ?
                <FeatureDialog
                    open={open}
                    setOpen={setOpen}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    getFeatures={getFeatures}
                />
                : dialogType === FEATURE_DIALOGS.CONFIRMATION_DIALOG ?
                    <AlertDialog
                        open={open}
                        setOpen={setOpen}
                        setSelectedRow={setSelectedRow}
                        confirmAction={handleDeleteClicked}
                    />
                    : null
            }
        </React.Fragment>
    );
}

export default Features;
